<!-- <div class="container card  d-flex justify-content-center mt-5"> -->
    <app-alerts *ngIf="showalertmsg"></app-alerts>
    
    <div class="box">
    <!-- nav options -->
    <ul class="nav nav-tabs" id="pills-tab" role="tablist">
        <li class="nav-item"> <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true" (click)="profileCheck()"><h6>Profile Details</h6></a> </li>
        <li class="nav-item"> <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false" (click)="manageAddress()"><h6>Manage Address</h6></a> </li>
        <li class="nav-item"> <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-password" role="tab" aria-controls="pills-password" aria-selected="false" (click)="passCheck()"><h6>Change Password</h6></a> </li>
    </ul> <!-- content-->
    <br>
    <div class="tab-content" id="pills-tabContent p-3">
        <!-- 1st card -->
        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
            <app-profile-details></app-profile-details>
        </div>
        <!---2nd card-->
        <div class="tab-pane fade show" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
            <app-customer-address></app-customer-address>
        </div>
        <!---3rd card-->
        <div class="tab-pane fade show" id="pills-password" role="tabpanel" aria-labelledby="pills-password-tab">
            <app-change-password></app-change-password>
        </div>
</div>
</div>
